import { NgModule } from '@angular/core';

import { TimezoneAutocompleteComponent } from './timezone-autocomplete.component';

@NgModule({
  imports: [TimezoneAutocompleteComponent],
  exports: [TimezoneAutocompleteComponent]
})
export class TimezoneAutocompleteModule {}
